// Merchant revenue (organisations.revenue_last_12_months) as typed by an admin.

// "250000", "250,000", "$250,000.50": a non-negative amount.
const REVENUE_PATTERN = /^\$?(\d{1,3}(,\d{3})+|\d+)(\.\d+)?$/;

/** The amount as a number, or null when it is empty or not a valid amount. */
export const parseRevenue = (value: unknown): number | null => {
  if (typeof value === 'number') return Number.isFinite(value) && value >= 0 ? value : null;
  if (typeof value !== 'string') return null;
  const trimmed = value.trim();
  if (!trimmed || !REVENUE_PATTERN.test(trimmed)) return null;
  const parsed = Number(trimmed.replace(/[$,]/g, ''));
  return Number.isFinite(parsed) ? parsed : null;
};

/** True when something was entered but it isn't a valid amount (empty is allowed). */
export const isInvalidRevenue = (value: unknown): boolean => {
  if (value === undefined || value === null) return false;
  if (typeof value === 'string' && !value.trim()) return false;
  return parseRevenue(value) === null;
};
